exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-box {\n  height: 400px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n.loading-box-content {\n  text-align: center;\n}\n.loading-box-content-spinner {\n  font-size: 32px;\n}\n.loading-box-content-title {\n  margin-top: 24px;\n}\n", ""]);

// exports
